import commun from "./commun";
import enumeration from "./enumeration";
import creation from "./creation";
import captcha from "./captcha";
import document from "./document";
import membre from "./membre";
import pieces from "./pieces";
import datatable from "./datatable";
import association from "./association";
import requete from "./requete";
import utilisateur from "./utilisateur";
import stamp from "./stamp";

export default {
    install(Vue) {
        commun.install(Vue);
        enumeration.install(Vue);
        creation.install(Vue);
        captcha.install(Vue);
        document.install(Vue);
        membre.install(Vue);
        pieces.install(Vue);
        datatable.install(Vue);
        association.install(Vue);
        requete.install(Vue);
        utilisateur.install(Vue);
        stamp.install(Vue);
    }
}
